import React, { Fragment } from 'react';
import { HomeIcon, ChevronRightIcon } from 'lucide-react';
interface BreadcrumbItem {
  label: string;
  href?: string;
}
interface PageHeroBreadcrumbProps {
  breadcrumbs: BreadcrumbItem[];
  title: string;
  description?: string;
  showTitle?: boolean;
  showDescription?: boolean;
}
export function PageHeroBreadcrumb({
  breadcrumbs,
  title,
  description,
  showTitle = true,
  showDescription = true
}: PageHeroBreadcrumbProps) {
  return <div className="bg-white border-b border-gray-100" data-id="element-3111" data-mp="kw504j5iy5vb">
      <div className="container mx-auto px-4 pt-4 pb-6 md:pt-8 md:pb-8" data-id="element-3112" data-mp="pu6guxfh9t3m">
        {/* Breadcrumb Navigation with Horizontal Scroll */}
        <div className="overflow-x-auto scrollbar-hide -mx-4 px-4 mb-3" data-id="element-3113" data-mp="uqwy3o30quqm">
          <nav className="flex items-center text-[13px] text-gray-500 whitespace-nowrap min-w-max" aria-label="Breadcrumb" data-id="element-3114" data-mp="zs2o3e5ao3wg">
            {breadcrumbs.map((item, index) => {
            const isLast = index === breadcrumbs.length - 1;
            return <Fragment key={index} data-id="element-3115" data-mp="7rt2nxe2hm6m" data-mpi={index}>
                  {index > 0 && <ChevronRightIcon className="w-3.5 h-3.5 mx-2 text-gray-400 flex-shrink-0" aria-hidden="true" data-id="element-3116" data-mp="2thpbcokctjn" />}
                  {item.href && !isLast ? <a href={item.href} className="hover:text-[#1E2B55] transition-colors flex items-center flex-shrink-0" data-id="element-3117" data-mp="3pyft3n4jqzfo">
                      {index === 0 && <HomeIcon className="w-3.5 h-3.5 mr-1.5 flex-shrink-0" data-id="element-3118" data-mp="3b9t4svwxyxcb" />}
                      <span data-id="element-3119" data-mp="378hjv3p0j0ag">{item.label}</span>
                    </a> : <span className={`flex items-center flex-shrink-0 ${isLast ? 'text-[#0f172a] font-medium' : ''}`} aria-current={isLast ? 'page' : undefined} data-id="element-3120" data-mp="3294w8gqbhp6t">
                      {index === 0 && <HomeIcon className="w-3.5 h-3.5 mr-1.5 flex-shrink-0" data-id="element-3121" data-mp="2nl4oo2vl7i3i" />}
                      <span data-id="element-3122" data-mp="2sjfxcaa5bmk5">{item.label}</span>
                    </span>}
                </Fragment>;
          })}
          </nav>
        </div>
        {/* Page Title - Conditionally rendered */}
        {showTitle && <h1 className="text-2xl md:text-[32px] font-bold text-[#0f172a] mb-2 tracking-tight" data-id="element-3123" data-mp="36cno5zqeke0s">
            {title}
          </h1>}
        {/* Description - Conditionally rendered */}
        {showDescription && description && <p className="text-sm md:text-base text-gray-600 leading-relaxed max-w-4xl" data-id="element-3124" data-mp="2wmufp7lk4f0r">
            {description}
          </p>}
      </div>
    </div>;
}